import HttpService from "./htttp.service";

class ServicesService {
  // ServicesEndpoint = process.env.API_URL;

  getServices = async () => {
    const getServices = "dash/services";
    return await HttpService.get(getServices);
  };

  createServices = async (payload) => {
    const createServices = "dash/services/new";
    return await HttpService.post(createServices, payload);
  };

  editServices = async (id, payload) => {
    const editServices = `dash/services/${id}`;
    return await HttpService.put(editServices, payload);
  };

  deleteServices = async (id, payload) => {
    const deleteServices = `dash/services/${id}`;
    return await HttpService.delete(deleteServices, payload);
  };
}

export default new ServicesService();
